export const projects = [

  {
    id: 12,
    title: "Vikn ERP",
    // date: "2024",
    description:
      "Vikn ERP is a Flutter-based Enterprise Resource Planning (ERP) application developed to streamline sales, purchase, inventory, invoicing, stock management, and branch transfer operations. The system supports offline functionality with local data storage, real-time synchronization, API integration, and responsive UI to improve business workflow efficiency.",
    image:
      "../assets/erpapp.png",
    tags: [
      "Flutter",
      "Dart",
      "REST API", "Offline Support",
      "Sqflite",
      "ERP System",
      "Inventory Management",
      "Invoice Management",
    ],
    category: "android app",
    github: "",
    role: "Mobile App",
    webapp: "https://play.google.com/store/apps/details?id=com.vikncodes.viknerp",
  },
  {
    id: 13,
    title: "Rassasy",
    // date: "2024",
    description:
      "Rassasy Restaurant POS is a Flutter-based restaurant Point of Sale (POS) application developed to streamline restaurant operations including order management, product handling, invoicing, tax management, customer management, and billing processes. The system supports offline functionality, local data storage, API integration, thermal printing, and responsive UI to ensure smooth restaurant business operations.",
    image:
      "../assets/rassasy.png",
    tags: [
      "Flutter",
      "Dart",
      "REST API",
      "Offline Support",
      "Sqflite",
      "Restaurant POS",
      "Thermal Printing",
      "Invoice Management",
      "Customer Management",
    ],
    category: "android app",
    github: "",
    role: "Mobile App",
    webapp: "https://play.google.com/store/apps/details?id=com.rassasy_tab.erp&hl=en_IN",
  },
  {
    id: 14,
    title: "Rassasy Kiosk",
    // date: "2024",
    description:
      "Rassasy Kiosk is a Flutter-based restaurant self-ordering kiosk application designed to streamline customer ordering and billing processes. The system enables customers to place table-wise orders, manage customer details, browse menu items, and generate invoices through an interactive self-service interface. Developed using Flutter, Dart, and REST API integration, the application ensures efficient restaurant order management and an improved customer experience.",
    image:
      "../assets/rassasykiosk.png",
    tags: [
      "Flutter",
      "Dart",
      "REST API",
      "Restaurant Kiosk",
      "Self Ordering",
      "Table-wise Ordering",
      "Invoice Management",
      "Customer Management",
    ],
    category: "android app",
    github: "",
    role: "Kiosk App",
    webapp: "",
  },
  {
    id: 15,
    title: "Netflix Clone",
    // date: "2024",
        video:
      "../assets/netflixvideo.mp4",
    description:
      "A Flutter-based Netflix-inspired movie discovery application built using the TMDB API. The app allows users to browse trending, popular, top-rated, and upcoming movies, search titles instantly, view detailed movie information, watch trailers, and manage a personalized favorites list. It follows Clean Architecture with BLoC state management to provide a scalable, maintainable, and responsive user experience.",
    image:
      "../assets/netflixclone.png",
    tags: [
      "Flutter",
      "Dart",
      "Bloc",
      "REST API",
      "TMDB API",
      "Dio/HTTP",
      "Clean Architecture",
    ],
    category: "android app",
    github: "",
    role: "Mobile App",
    webapp: "",
  },
  {
    id: 11,
    title: "ViknBooks POS",
    // date: "2024",
    description:
      "ViknBooks POS is a Flutter-based Point of Sale application developed to streamline billing, inventory tracking, sales management, and payment processing. The system includes real-time data handling, offline storage support, API integration, and responsive UI for efficient retail business operations.",
    image:
      "../assets/viknbookspos.png",
    tags: [
      "Flutter",
      "Dart",
      "REST API",
      "Sqflite",
      "WebSocket",
      "A4 Printing",
      "Thermal Printing",
      "Theme Customization",
      "PDF Generation",
    ],
    category: "android app",
    github: "",
    role: "Windows App",
    webapp: "",
  },
  {
    id: 9,
    title: "News API App",
    // date: "Oct 2022 - April 2023",
    video:
      "../assets/newapivideo.mp4",
    description:
      "I developed a user-friendly Flutter News API application that efficiently connects to news data through robust API integrations. This project highlights my expertise in mobile app development, seamless API integration, and intuitive UI design.",
    image:
      "../assets/newsapi.jpg",
    tags: [
      "Flutter",
      "Dart",
      "API",
    ],
    category: "android app",
    github: "https://github.com/MidhunrajGit0022/News_API",
    role: "Mobile App"
    // webapp: "www.google.com",
  },
  {
    id: 1,
    title: "Shopping App",
    // date: "Oct 2022 - April 2023",
    video:
      "../assets/Amazonapi.mp4",
    description:
      "I have created a user-friendly Flutter shopping app that seamlessly connects to product data through APIs. This project demonstrates my strong skills in app development, API integration, and UI design.",
    image:
      "../assets/amazon.png",
    tags: [
      "Flutter",
      "Dart",
      "API",
    ],
    category: "android app",
    github: "https://github.com/MidhunrajGit0022/Shopping_App_API",
    role: "Mobile App"
    // webapp: "www.google.com",
  },
  {
    id: 2,
    title: "Blood Donation App",
    // date: "Oct 2022 - April 2023",
    description:
      "Created a Flutter-based blood donation app featuring comprehensive CRUD operations. Users can effortlessly Create, Read, Update, and Delete donor profiles,. The app streamlines blood donation management, enhancing accessibility and efficiency in the process.",
    image:
      "../assets/bloodapp.png",
    tags: [
      "Flutter",
      "Dart",
      "Firebase",

    ],
    category: "android app",
    github: "https://github.com/MidhunrajGit0022/Blood_Donation_App_CRUD",
    role: "Mobile App"
    // webapp: "www.google.com",
  },
  // {
  //   id: 3,
  //   title: "AddressBuk",
  //   date: "Jan 2023 - Current",
  //   description:
  //     "Developed live Flutter project with Firebase integration for efficient shop discovery. Features Admin, Staff, and Public roles. Admins manage staff and shops; Staff update shop details. Public users search nearby shops, rate, and provide feedback. This project is live and showcases my skills in Flutter and Firebase.",
  //   image:
  //     "../assets/underconstruction.png",
  //   tags: [
  //     "Flutter",
  //     "Dart",
  //     "Firebase",
  //   ],
  //   category: "android app",
  //   // github: "https://github.com/MidhunrajGit0022/Shopping_App_API",
  //   role: "Flutter (Search Application)"
  //   // webapp: "www.google.com",
  // },
  {
    id: 10,
    title: "Bicycle_Website",
    date: "Ecommerce Platform",
    description:
      "Developed a bicycle eCommerce platform using the MERN stack, implementing Redux for efficient state management. Utilized JWT tokens for secure user authentication and enhanced security, delivering a seamless and user-friendly shopping experience for cycling enthusiasts.",
    image:
      "../assets/cyclethumb.png",
    video:
      "../assets/cyclevideo.mp4",
    tags: [
      "React",
      "CSS",
      "Javascript",
      "Express.js",
      "Node.js",
      "Redux",
      "MongoDb",
    ],
    category: "web app",
    github: "https://github.com/MidhunrajGit0022/Bicycle_Website",
    mainrole: "Mern Project",
    // role: "Mern Project",
    // webapp: "https://midhunrajgit0022.github.io/Streamo_Clone_Webpage/",
  },
  {
    id: 7,
    title: "SocialZone",
    date: "Socialmedia Platform",
    description:
      "A React-based social media platform, equipped with a simple CRUD application using MERN Stack, empowers users to efficiently manage their online presence. It offers a range of essential tools for social media management.",
    image:
      "../assets/socialmediathumb.png",
    video:
      "../assets/socialmedia_website.mp4",
    tags: [
      "React",
      "CSS",
      "Javascript",
      "MongoDb",
      "Express.js",
      "Node.js",
    ],
    category: "web app",
    github: "https://github.com/MidhunrajGit0022/Socialzone",
    mainrole: "Mern Project",
    // role: "Mern Project",
    // webapp: "https://midhunrajgit0022.github.io/Streamo_Clone_Webpage/",
  },
  {
    id: 4,
    title: "Webhost",
    date: "Sep 2023 - Oct 2023",
    description:
      "Webhost is a React-based UI project designed to showcase frontend skills. With its modern design and user-friendly approach, Webhost offers a seamless and engaging experience for users exploring webhosting platform.",
    image:
      "../assets/webhost_react.png",
    video:
      "../assets/Webhost_Clone_Webpage.mp4",
    tags: [
      "React",
      "React-Bootstrap",
      "CSS",
    ],
    category: "web app",
    github: "https://github.com/MidhunrajGit0022/Webhost_Clone_Webpage",
    role: "Front-end Development",
    webapp: "https://midhunrajgit0022.github.io/Webhost_Clone_Webpage/",
  },
  {
    id: 5,
    title: "Streamo",
    date: "Aug 2023 - Sep 2023",
    description:
      "Streamo is an HTML, CSS, and JavaScript-based Clone UI project designed to showcase frontend skills. With its modern design and user-friendly approach, Streamo offers a seamless and engaging experience for users exploring the platform.",
    image:
      "../assets/streamo.png",
    video:
      "../assets/Streamovideo.mp4",
    tags: [
      "Html",
      "CSS",
      "Javascript"
    ],
    category: "web app",
    github: "https://github.com/MidhunrajGit0022/Streamo_Clone_Webpage",
    role: "Front-end Development",
    webapp: "https://midhunrajgit0022.github.io/Streamo_Clone_Webpage/",
  },
  {
    id: 6,
    title: "Shopping Website",
    // date: "Aug 2023 - Sep 2023",
    description:
      "I have created a user-friendly React-based shopping website that seamlessly connects to product data through APIs. This project demonstrates my strong skills in Web development, API integration, and UI design.",
    image:
      "../assets/thumb onlineshop.png",
    video:
      "../assets/Online Shopping Video.mp4",
    tags: [
      "Html",
      "CSS",
      "Javascript",
      "Fake Store API"
    ],
    category: "web app",
    github: "https://github.com/MidhunrajGit0022/Shopping_Website_API",
    role: "Front-end Development",
    // webapp: "https://midhunrajgit0022.github.io/Streamo_Clone_Webpage/",
  },
  {
    id: 8,
    title: "Aero_Clone_Website",
    // date: "Aug 2023 - Sep 2023",
    description:
      "AeroShip is a React-based UI project designed to showcase frontend skills. With its modern design, user-friendly approach, and complete responsive website, AeroShip offers a seamless and engaging experience for users exploring the platform.",
    image:
      "../assets/aeroship.png",
    tags: [
      "React",
      "Tailwind",
    ],
    category: "web app",
    github: "https://github.com/MidhunrajGit0022/Aero_Clone",
    role: "Front-end Development",
    webapp: "https://aero-clone.vercel.app/",
  },


]